module.exports = __webpack_public_path__ + "img/12.eb199d7d.jpeg";